<template>
  <div class="content mb-5">
    <b-row class="mb-5">
      <b-col>
        <t-data-table
          data-test-id="administrators-data-table"
          with-filter
          hoverable
          :filter-placeholder="$t('Search Admins')"
          :loading="loading"
          :title="this.$t('All Administrators')"
          :table-data="dataSet"
          :actions="tableActions"
          user-role="msp"
          @on-add="onAdd"
          @on-export="onExport"
          @on-delete="onDelete"
          @on-row-clicked="onRowClicked"
          :searchExports="searchExports"
          @export-headers="exportedHeaders"
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "MSP Administrators"
}
</route>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  layout: "msp",
  methods: {
    ...mapActions("pageMeta", ["setPageTitle"]),
    ...mapActions("admins", ["fetchAdmins", "deleteAdmins"]),
    ...mapMutations("modal", ["createModal", "showModal"]),
    ...mapActions("toast", ["displayToast"]),
    onRowClicked(item) {
      this.$router.push(`/msp/global_settings/administrators/${item.id}`);
    },
    onAdd() {
      this.createModal({
        modal: "t-add-administrator",
        dataTestId: "modal-add-administrator",
        title: this.$t("Add an Administrator"),
        subtitle: this.$t("New"),
        modalData: {
          customerType: "msp",
        },
        props: {
          size: "lg",
          okTitle: this.$t("Add Administrator"),
        },
      });

      this.showModal();
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "All_Administrators");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No customers in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
    async onDelete(items) {
      try {
        let selected_user_id = this.selectedUser ? this.selectedUser.id : "";
        selected_user_id =
          selected_user_id === 0 || selected_user_id === undefined
            ? ""
            : selected_user_id;
        items.user_id = selected_user_id;
        items.msp_id = this.mspId === 0 ? "" : this.mspId;

        await this.deleteAdmins(items);
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Deleted: X", { item: items.length }),
          duration: 2000,
          variant: "success",
        });
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      }
    },
  },
  watch: {
    Admins: {
      handler() {
        this.dataSet.items = this.Admins;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("admins", ["Admins"]),
    ...mapGetters("authentication", [
      "selectedUser",
      "selectedMspUser",
      "mspId",
    ]),
  },
  async created() {
    let selected_user_id = this.selectedUser ? this.selectedUser.id : "";
    selected_user_id =
      selected_user_id === 0 || selected_user_id === undefined
        ? ""
        : selected_user_id;
    this.setPageTitle(this.$t("Administrators"));
    try {
      await this.fetchAdmins({
        msp_id: this.mspId === 0 ? "" : this.mspId,
        user_id: selected_user_id,
      });
    } finally {
      this.dataSet.items = this.Admins;
      this.loading = false;
    }
  },
  data: function () {
    return {
      loading: true,
      currentHeaders: null,
      tableActions: {
        add: {
          enabled: true,
          actions: [
            {
              text: this.$t("Add"),
              value: "add",
            },
          ],
        },
        export: { enabled: true },
        import: { enabled: false },
        delete: { enabled: true },
      },
      searchExports: ["fullname", "description", "email"],
      dataSet: {
        fields: [
          { value: "fullname", text: this.$t("Full Name"), sortable: true },
          { value: "email", text: this.$t("Email"), sortable: true },
          {
            value: "description",
            text: this.$t("Description"),
            sortable: true,
          },
          { value: "lastlogin", text: this.$t("Last Login"), sortable: true },
          { value: "lastip", text: this.$t("Last Login IP"), sortable: true },
        ],
        items: [],
      },
    };
  },
};
</script>
